import React, { useState } from 'react';
import {
  Box,
  TextField,
  FormControlLabel,
  Checkbox,
  Button,
  Typography,
  Paper,
  Grid,
  Divider
} from '@mui/material';

const SubUserForm = ({ onSubmit, onCancel, initialData }) => {
  const [formData, setFormData] = useState({
    name: initialData?.name || '',
    email: initialData?.email || '',
    password: '',
    permissions: initialData?.permissions || {
      canEditProducts: false,
      canDeleteProducts: false,
      canCreateProducts: false,
      canViewAnalytics: false,
      canManageSubUsers: false,
      canChangeOwnPassword: true,
      canPauseProducts: false,
      canEditDistributorInfo: false
    }
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handlePermissionChange = (permission) => {
    setFormData(prev => ({
      ...prev,
      permissions: {
        ...prev.permissions,
        [permission]: !prev.permissions[permission]
      }
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
  };

  return (
    <Paper sx={{ p: 3 }}>
      <Typography variant="h6" gutterBottom>
        {initialData ? 'Editar Sub-usuario' : 'Nuevo Sub-usuario'}
      </Typography>
      <form onSubmit={handleSubmit}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Nombre de usuario"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Email"
              name="email"
              type="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </Grid>
          {!initialData && (
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Contraseña"
                name="password"
                type="password"
                value={formData.password}
                onChange={handleChange}
                required={!initialData}
              />
            </Grid>
          )}
        </Grid>

        <Divider sx={{ my: 3 }} />
        
        <Typography variant="subtitle1" gutterBottom>
          Permisos
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={formData.permissions.canCreateProducts}
                  onChange={() => handlePermissionChange('canCreateProducts')}
                />
              }
              label="Crear productos"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={formData.permissions.canEditProducts}
                  onChange={() => handlePermissionChange('canEditProducts')}
                />
              }
              label="Editar productos"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={formData.permissions.canDeleteProducts}
                  onChange={() => handlePermissionChange('canDeleteProducts')}
                />
              }
              label="Eliminar productos"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={formData.permissions.canPauseProducts}
                  onChange={() => handlePermissionChange('canPauseProducts')}
                />
              }
              label="Pausar productos"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={formData.permissions.canViewAnalytics}
                  onChange={() => handlePermissionChange('canViewAnalytics')}
                />
              }
              label="Ver análisis"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={formData.permissions.canEditDistributorInfo}
                  onChange={() => handlePermissionChange('canEditDistributorInfo')}
                />
              }
              label="Editar información del distribuidor"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={formData.permissions.canManageSubUsers}
                  onChange={() => handlePermissionChange('canManageSubUsers')}
                />
              }
              label="Gestionar sub-usuarios"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={formData.permissions.canChangeOwnPassword}
                  onChange={() => handlePermissionChange('canChangeOwnPassword')}
                />
              }
              label="Cambiar contraseña propia"
            />
          </Grid>
        </Grid>

        <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
          <Button onClick={onCancel}>
            Cancelar
          </Button>
          <Button type="submit" variant="contained" color="primary">
            {initialData ? 'Guardar cambios' : 'Crear sub-usuario'}
          </Button>
        </Box>
      </form>
    </Paper>
  );
};

export default SubUserForm; 